<div class="item-row">
    <div class="item-cell thumbnail-container">
        <img *ngIf="data.thumbnail;" [src]="data.thumbnail">
    </div>
    <div class="item-cell title-cell">
        <div class="title-container">
            <span class="title">{{ data.title }}</span>
            <span class="tag"> {{ data.tag }}</span>
        </div>
    </div>
    <div class="item-cell visitors-cell">
        <div class="visitor-cell-number">
            <span class="visitor-cell-number-label">Viewed by</span>
            <span class="visitor-cell-number-value"> {{ data.usersNum || 0 }} users</span>
        </div>
        <div class="visitor-cell-gauge" matTooltip="Percentage of visitors who viewed this scene">
            <mwl-gauge
                [dialStartAngle]="-90"
                [dialEndAngle]="-90.001"
                [max]="100"
                [value]="data.userPercent || 0"
                [label]="getLabel.bind(this)">
            </mwl-gauge>
        </div>
    </div>
    <div class="item-cell data-cell">
        <ng-container *ngIf="data.quizNum && data.quizNum > 0"> 
            <span class="data-number">{{ data.quizNum }} </span>
            <span class="data-label">{{ data.quizNum > 1 ? 'quizzes' : 'quiz' }}</span>
        </ng-container>
    </div>
    <div class="item-cell data-cell">
        <ng-container *ngIf="data.annotationNum && data.annotationNum > 0"> 
            <span class="data-number">{{ data.annotationNum }} </span>
            <span class="data-label">{{ data.annotationNum > 1 ? 'actions' : 'action' }}</span>
        </ng-container>
    </div>
</div>
